import { DropdownItem, DropdownMenu, Switch, Tab, Tabs } from '@heroui/react'
import { useEffect, useState } from 'react'
import { useUserPrefs } from '../../context/UserPrefsContext'

export default function SettingsMenu() {
  const { userPrefs, updateUserPrefs, setGyroPermission } = useUserPrefs()
  // Create local state to ensure UI updates immediately
  const [subtitlesOn, setSubtitlesOn] = useState(!!userPrefs.subtitlesEnabled)
  const [motionOn, setMotionOn] = useState(!!userPrefs.useGyro)

  const isMobile = userPrefs.isMobile
  const subtitleMode = userPrefs.subtitleLanguage

  // Sync local state with context when userPrefs changes
  useEffect(() => {
    setSubtitlesOn(!!userPrefs.subtitlesEnabled)
    setMotionOn(!!userPrefs.useGyro)
  }, [userPrefs.subtitlesEnabled, userPrefs.useGyro])

  const handleSubtitleSwitch = (checked: boolean) => {
    setSubtitlesOn(checked) // Update local state immediately
    updateUserPrefs({ subtitlesEnabled: checked })
  }

  const handleMotionSwitch = (checked: boolean) => {
    setMotionOn(checked) // Update local state immediately
    setGyroPermission(checked)
  }

  const handleSubtitleMode = (mode: 'both' | 'english' | 'maori') => {
    updateUserPrefs({
      subtitleLanguage: mode,
      subtitlesEnabled: true,
    })
  }

  return (
    <DropdownMenu className="w-64 p-4">
      {subtitlesOn ? (
        <DropdownItem key="subtitle-tabs" textValue="Subtitle Language" isReadOnly className="flex-col items-start">
          <Tabs
            aria-label="Subtitle Language"
            selectedKey={subtitleMode}
            onSelectionChange={(key) => handleSubtitleMode(key as 'both' | 'english' | 'maori')}
            variant="solid"
            size="sm"
            className="w-full"
          >
            <Tab key="both" title="Both" />
            <Tab key="english" title="English" />
            <Tab key="maori" title="Te Reo" />
          </Tabs>
        </DropdownItem>
      ) : null}

      <DropdownItem
        key="subtitles"
        textValue="Subtitles"
        isReadOnly
        endContent={<Switch isSelected={subtitlesOn} onValueChange={handleSubtitleSwitch} className="ml-0" />}
      >
        Subtitles
      </DropdownItem>

      {isMobile ? (
        <DropdownItem
          key="motion"
          textValue="Motion Controls"
          isReadOnly
          endContent={<Switch isSelected={motionOn} onValueChange={handleMotionSwitch} className="ml-0" />}
        >
          Motion Controls
        </DropdownItem>
      ) : null}
    </DropdownMenu>
  )
}
